import { useEffect } from 'react';
import { ChainId, NATIVE_ADDRESS } from '@shared/utils/config/networks';
import { useRouter } from 'next/router';
import FullScreenGuard from '@/components/auth/FullScreenGuard';
import MobileMenu from '@/components/shared/MobileMenu';
import SwapHomeMobile from '@/components/trade/swap-home/SwapHomeMobile';
import SwapLoader from '@/components/trade/SwapLoader';
import { useSwap } from '@/contexts/SwapProvider';
import useLitSession from '@/hooks/LitSessionContext/useLitSession';
import { convertBasicTokenInfoToCovalentBalanceItem, getBasicTokenInfo } from '@/hooks/pricing/useBasicTokenInfo';
import useERC20Balance from '@/hooks/portfolio/useERC20Balance';
import { transformAddress } from '@/lib/asset/nativeAddressHelper';
const TradeMobileController = () => {
  const router = useRouter();
  const {
    PKP
  } = useLitSession();
  const {
    data: cloudWalletBalance,
    isLoading: loadingBalance
  } = useERC20Balance({
    evmAddresses: [PKP?.additionalEthAddress],
    solanaAddresses: [PKP?.solanaAddress]
  });
  const {
    setToAssets,
    setFromAssets,
    resetAssets
  } = useSwap();
  let networkId: string | string[] = router.query.networkId;
  const {
    address: queryAddress
  } = router.query;
  if (Array.isArray(networkId)) {
    networkId = networkId[0];
  }
  useEffect(() => {
    const {
      address: tAddres
    } = transformAddress(queryAddress, networkId);
    handleSetAssets(networkId, tAddres);
  }, [router.query]);
  const handleSetAssets = async (network: any, address: any) => {
    const tokenData = await getBasicTokenInfo(network, address);
    if (queryAddress?.toLowerCase() == NATIVE_ADDRESS?.toLowerCase()) {
      tokenData.token.address = NATIVE_ADDRESS?.toLowerCase();
      if (network == ChainId.AVALANCHE) {
        tokenData.token.symbol = 'AVAX';
      } else if (network == ChainId.BSC) {
        tokenData.token.symbol = 'BNB';
      } else if (network == ChainId.POLYGON) {
        tokenData.token.symbol = 'POL';
      } else {
        tokenData.token.symbol = 'ETH';
      }
    }
    if (!tokenData || !tokenData.token) {
      resetAssets();
      return;
    }
    if (router?.query?.side == 'from' && cloudWalletBalance) {
      const tokenInfo = cloudWalletBalance.balances.find(token => token.contract_address === router.query.address?.toString() && token.network === Number(router.query.networkId));
      console.log('TradeMobileController:handleSetAssets:tokenInfo', tokenInfo);
      if (tokenInfo?.usd_value) {
        setFromAssets([{
          ...convertBasicTokenInfoToCovalentBalanceItem(tokenData),
          ...tokenInfo,
          percentage: 100,
          amountToUse: 0,
          amountToUseStr: '0'
        }]);
        setToAssets([]);
      }
      return;
    }
    setToAssets([{
      ...convertBasicTokenInfoToCovalentBalanceItem(tokenData),
      percentage: 100
    }]);
    setFromAssets([]);
  };
  if (loadingBalance) return <>
        <SwapLoader />;
        <MobileMenu />
      </>;
  return <div className='' data-sentry-component="TradeMobileController" data-sentry-source-file="TradeMobileController.tsx">
      <div className='bg-genius-indigo h-full flex max-h-screen'>
        <div className='content flex flex-col w-full'>
          <div className='text-genius-pink text-center'>
            <div className='w-full relative'>
              <FullScreenGuard data-sentry-element="FullScreenGuard" data-sentry-source-file="TradeMobileController.tsx">
                <SwapHomeMobile data-sentry-element="SwapHomeMobile" data-sentry-source-file="TradeMobileController.tsx" />
              </FullScreenGuard>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default TradeMobileController;